import { Button, ButtonStyle, DescriptionList, MenuItem } from "@prequel/shared-components";

export type DangerZoneAction = {
  label: string;
  description: string;
  buttonText: string;
  onClick?: () => void;
  menuItems?: MenuItem[];
  hidden?: boolean;
};

type DangerZoneProps = {
  actions: DangerZoneAction[];
  type?: "list" | "card";
};
const DangerZone = ({ actions, type = "list" }: DangerZoneProps) => {
  const visibleActions = actions.filter(({ hidden = false }) => !hidden);

  if (type === "card") {
    return (
      <section>
        <h3 className="mb-3 text-sm font-medium text-stone-800">Danger zone</h3>
        {visibleActions.map(({ label, description, buttonText, onClick, menuItems }) => (
          <div key={label} className="mb-4 rounded-md border border-red-300 bg-white p-4">
            <h4 className="mb-1 text-sm font-medium text-red-600">{label}</h4>
            <p className="mb-3 text-sm text-stone-600">{description}</p>
            <Button text={buttonText} type={ButtonStyle.DANGER} onClick={onClick} menuItems={menuItems} />
          </div>
        ))}
      </section>
    );
  }

  return (
    <section className="mt-10 divide-y divide-red-300">
      <header className="space-y-1 pb-6">
        <h3 className="text-lg/6 font-medium text-gray-900">Danger Zone</h3>
        <p className="max-w-2xl text-sm text-gray-500">Actions in this section should be considered carefully.</p>
      </header>
      <div>
        <DescriptionList type="danger">
          {visibleActions.map(({ label, description, buttonText, onClick, menuItems }) => (
            <DescriptionList.ButtonItem key={label} label={label} description={description}>
              <Button text={buttonText} type={ButtonStyle.DANGER} onClick={onClick} menuItems={menuItems} />
            </DescriptionList.ButtonItem>
          ))}
        </DescriptionList>
      </div>
    </section>
  );
};

export default DangerZone;
